import React, { useCallback, useState } from "react";
import "devextreme/dist/css/dx.light.css";
import "./EnvironmentTile.scss";
import { Popover } from "devextreme-react/popover";
import PropTypes from "prop-types";
import { Button } from "devextreme-react/button";
import { orgInfoSvg, editOrgSvg } from "../../Assets/SVGs/organizationSVGs";
import { orgDataPropTypes } from "../../Constants/propTypes";
import { useUser } from "../../contexts/UserContext";
import { Roles } from "../../Constants/constants";

const EnvironmentTile = ({
  orgData,
  toggleEditPopupForPartner,
  renderToolTip,
  getClickableLinkForOrg,
}) => {
  const [isToolTipVisible, setIsToolTipVisible] = useState(false);

  const { userRoles } = useUser();

  const isSuperUser = userRoles?.includes(Roles.SUPER_USER);
  const isOrgAdmin = userRoles?.includes(Roles.ORG_ADMIN);

  const toggleShowTooltip = useCallback(() => {
    setIsToolTipVisible(!isToolTipVisible);
  }, [isToolTipVisible]);

  return (
    <div id="environmenttile-div-datagridenvironment">
      <div className="orgInfo">
        <div className="orgInfo-row">
          <div className="org-details">
            <div className="ord-details-title">
              <div className="ord-details-title-col-1">
                <div className="d-flex">
                  <div>{orgData?.name}</div>
                  <div className="edit-org-icons">
                    <Button
                      onClick={toggleShowTooltip}
                      stylingMode="text"
                      width={20}
                      height={20}
                    >
                      &nbsp;
                      {orgInfoSvg(isToolTipVisible)}
                    </Button>
                  </div>
                  <div className="edit-org-icons">
                    {(isSuperUser || isOrgAdmin === true) && orgData.parentId !== null ? (
                      <Button
                        onClick={toggleEditPopupForPartner}
                        stylingMode="text"
                        width={20}
                        height={20}
                      >
                        {editOrgSvg}
                      </Button>
                    ) : (
                      <div />
                    )}
                  </div>
                </div>
                <Popover
                  target="#organizationsvgs-svg-info"
                  contentRender={renderToolTip}
                  width={484}
                  visible={isToolTipVisible}
                  onHiding={toggleShowTooltip}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="org-details">
          <div className="d-flex header-container">
            <div title={orgData.email}>
              &nbsp;
              {orgData.email}{" "}
            </div>
            <div>
              &nbsp; |{" "}
              <span className="p-1" title={orgData.website}>
                &nbsp;
                <a
                  href={getClickableLinkForOrg(orgData.website)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  &nbsp;
                  {orgData.website}&nbsp;
                </a>
              </span>
            </div>
            <div>
              &nbsp;
              <span
                className="p-1"
                title={`Ph: (${orgData.phone.slice(0, 3)}) ${orgData.phone.slice(
                  3,
                  6
                )}-${orgData.phone.slice(6)}`}
              >
                | Ph: ({orgData.phone.slice(0, 3)}) &nbsp;
                {orgData.phone.slice(3, 6)}-{orgData.phone.slice(6)}
              </span>
              &nbsp;
            </div>
            <div
              title={`Created on: ${orgData.createDate.slice(
                5,
                7
              )}-${orgData.createDate.slice(8, 10)}-${orgData.createDate.slice(0, 4)}`}
            >
              <span className="p-1">|</span> Created on:&nbsp;
              {orgData.createDate.slice(5, 7)}-{orgData.createDate.slice(8, 10)}-
              {orgData.createDate.slice(0, 4)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
EnvironmentTile.propTypes = {
  orgData: orgDataPropTypes.isRequired,
  toggleEditPopupForPartner: PropTypes.func.isRequired,
  renderToolTip: PropTypes.func.isRequired,
  getClickableLinkForOrg: PropTypes.func.isRequired,
};
export default EnvironmentTile;
